import script from "./MessageboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageboardView.vue?vue&type=script&setup=true&lang=js"

import "./MessageboardView.vue?vue&type=style&index=0&id=91946ce8&lang=css"

const __exports__ = script;

export default __exports__